<template>
    <div class="position-box">
        <div class="country-wrap">
            <div class="search-wrap">
                <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
                <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
                <div class="text">{{$t('level1.qxzgjlb')}}</div>
            </div>
            <div class="search-box" v-if="language == 'ar'">
                <input class="search" type="text" v-model="key" @input="search" placeholder="search">
                <img class="icon" src="@/assets/sousuo1.png" alt="">
            </div>
            <div class="search-box" v-else>
                <img class="icon" src="@/assets/sousuo1.png" alt="">
                <input class="search" type="text" v-model="key" @input="search" placeholder="search">
            </div>
            <ul id="listenScroll" class="country-box" v-if="language == 'ar'">
                <li class="country-li" v-for="(item,index) in country" :key="index" @click="select(item[lang],item.area_code)">
                    <span class="code">{{item.area_code}}</span>
                    <div class="country">
                        <span class="text">{{item[lang]}}</span>
                        <img class="img" style="margin: 0 0 0 .3rem" :src="item.icon" />
                    </div>
                </li>
            </ul>
            <ul id="listenScroll" class="country-box" v-else>
                <li class="country-li" v-for="(item,index) in country" :key="index" @click="select(item[lang],item.area_code)">
                    <div class="country">
                        <img class="img" :src="item.icon" />
                        <span class="text">{{item[lang]}}</span>
                    </div>
                    <span class="code">{{item.area_code}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'city',
    data () {
        return {
          theme: false,
          key: '',
          lang: 'en',
          language: 'en',
          country: country
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.language = localStorage.getItem('language') || 'en';
    },
    mounted() {
        var lang = localStorage.getItem('language') || 'en';
        if(lang == "tw"){
            this.lang = 'ft';
        }else if(lang == 'zh'){
            this.lang = 'zh';
        }else if(lang == 'de'){
            this.lang = 'dy';
        }else if(lang == 'fr'){
            this.lang = 'fy';
        }else if(lang == 'kr'){
            this.lang = 'hy';
        }else if(lang == 'th'){
            this.lang = 'ty';
        }else if(lang == 'fy'){
            this.lang = 'fy';
        }else if(lang == 'vn'){
            this.lang = 'yn';
        }else if(lang == 'es'){
            this.lang = 'ag';
        }else if(lang == 'ar'){
            this.lang = 'alb';
        }else{
            this.lang = lang;
        }
    },
    methods: {
       goBack(){
           this.$router.go(-1)
       },
       search(){
           if(this.key){
                this.country = country.filter((item)=>{
                 return (item.area_code.indexOf(this.key) > -1 || item[this.lang].indexOf(this.key) > -1)
                })
           }else{
               this.country = country
           }
       },
       select(city,code){
           localStorage.setItem('country',city);
           localStorage.setItem('area_code', '+' + code);
           this.$router.back()
       }
    }
}
</script>
<style scoped>
    .country-wrap{
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        z-index: 1000;
        width: 100%;
        height: auto;
        background: #fff;
    }
    .country-box {
        position: absolute;
        z-index: 9;
        top: 2.8rem;
        left: .3rem;
        right: .3rem;
        bottom: 0;
        height: auto;
        background: #fff;
        overflow-y: scroll;
    }
    .country-wrap .search-wrap{
        display: flex;
        align-items: center;
        padding: .24rem .3rem;
        color: #000;
        font-size: .48rem;
    }
    .country-wrap .search-wrap .text{
        flex: 1;
        text-align: center;
    }
    .country-wrap .search-box{
        position: relative;
        z-index: 10;
        display: flex;
        align-items: center;
        margin: .3rem;
        padding: .12rem .24rem;
        border-radius: 4px;
        background: #f3f3f3;
        box-sizing: border-box;
    }
    .country-wrap .back{
        width: .5rem;
    }
    .country-wrap .icon{
        width: .6rem;
        height: .6rem;
    }
    .country-wrap .search{
        flex: 1;
        height: 30px;
        color: #000;
        font-size: .42rem;
        text-indent: .12rem;
        padding-right: .12rem;
    }
    .country-wrap .country-li{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .3rem;
    }
    .country-wrap .country-li .country{
        display: flex;
        align-items: center;
    }
    .country-wrap .country-li .img{
        width: .75rem;
        height: .75rem;
        margin-right: .3rem;
    }
    .country-wrap .country-li .code{
        color: #87a2cd;
    }
</style>



// WEBPACK FOOTER //
// src/pages/city.vue